export default {
  example: false,
  allowRefreshSession: false,
  expirationAlertLimit: 10,
  ticketLimitHours: 48,
  allowDarkThemeButton: true,
  enableResetAccount: true,
  enableCancelAccount: false,
  showCommentsInPerson: false,
  contractSearchColumns: '',
  logsMenu: false,
  assessmentAgents: null,
  offHoursText: null,
  onHoursText: ['Segunda a Sexta - 7hs às 19:55hs', 'Sábado - 8hs às 17:45hs', 'Feriados - 8hs às 17:45hs'],
  enableAccessByClient: false,
  enableAcceptTerms: false,
  enableForceDownload: true,
  showUpdateButtonOnDistributedContracts: true,
  byPassRoles: [],
  allowEditOpportunityValue: false,
  enableOpportunitySimulation: false,
  hiddenFeatures: [],
  hideFromHomolog: [],
  hideFromProd: [],
  commentEditHourLimit: 1,
  refundStatusTexts: {},
  // Textos do bloco Diagnostico da antecipacao de recebiveis, chaveados pelo CODIGO do
  // status do termo (ex.: { "40": { whatToTellClient: "..." } }). Override parcial sobre
  // os defaults de advanceStatus.ts -- mesmo mecanismo do refundStatusTexts acima.
  advanceStatusTexts: {},
};
